// src/modules/app-views/products/pages/Document/tabs/StockTab/ProductGridContent.jsx
// *******************************************************************************
// PRODUCT GRID COLLAPSE CONTENT
// *******************************************************************************
// Variant mode (none/single_attribute/multi_attribute).
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { Col, Row, Form, Tooltip } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import translateX from 'utils/translateX';
import SimpleSegment from 'components/SimpleComponents/SimpleSegment';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const NO_VARIANTS_PURPOSES = ['semi_finished', 'consumption', 'packaging', 'digital'];

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ProductGridContent = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { form } = useSimpleFormContext() || {};

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const purpose = Form.useWatch(['stock', 'purpose'], form) || 'resale';
  const isUnique = Form.useWatch(['stock', 'isUnique'], form) || false;

  const canVariants = !NO_VARIANTS_PURPOSES.includes(purpose) && !isUnique;

  const variantOptions = useMemo(() => [
    { value: 'none', label: translateX('tracking_none') },
    {
      value: 'single_attribute',
      label: (
        <Tooltip title={translateX('grid_1d')}>
          {translateX('simple')}
        </Tooltip>
      ),
    },
    {
      value: 'multi_attribute',
      label: (
        <Tooltip title={translateX('grid_2d')}>
          {translateX('matrix')}
        </Tooltip>
      ),
    },
  ], []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleVariantModeChange = value => {
    if (!form) return;
    if (value === 'none') {
      form.setFieldValue(['stock', 'variantAttributes'], []);
    }
    if (value !== 'none') {
      form.setFieldValue(['stock', 'isUnique'], false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Row gutter={ROW_GUTTER}>
      <Col xs={24} sm={12} lg={8}>
        <SimpleSegment
          name={['stock', 'variantMode']}
          label="variants"
          options={variantOptions}
          block
          disabled={!canVariants}
          onChange={handleVariantModeChange}
        />
      </Col>
    </Row>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ProductGridContent;
